import React, { useState, useEffect, useContext } from "react";
import "./style.css";
import { VscGrabber, VscClose } from "react-icons/vsc";
import { Link } from "react-router-dom";
import { menu_options } from "../content_option";
import Themetoggle from "../components/themetoggle";
import LanguageToggle from "../components/languagetoggle";
import { LanguageContext } from "../data/language_context";

// Helper for language suffix
const getLangKey = (selectedLang) => {
  switch (selectedLang) {
    case "Spanish": return "_esp";
    case "Catalan": return "_cat";
    case "English":
    default: return "_eng";
  }
};

const Headermain = () => {
  const { language: selectedLang } = useContext(LanguageContext);
  const langSuffix = getLangKey(selectedLang);

  const getMenuText = (baseKey) => {
    return menu_options[`${baseKey}${langSuffix}`] || menu_options[`${baseKey}_eng`];
  };

  const [isActive, setActive] = useState(false);

  useEffect(() => {
    document.body.classList.toggle("ovhidden", isActive);
  }, [isActive]);

  const handleToggle = () => setActive(!isActive);

  return (
    <>
      <header className="site-header">
        <div className="header-inner">
          {/* Logo */}
          <Link to="/" className="logo-link">
            <img
              src="/images/logos/ailleratech.png"
              alt="AIllera Technologies Logo"
              className="logo"
            />
          </Link>

          {/* Right Side Controls */}
          <div className="header-controls">
            <Themetoggle />
            <button
              className="menu-button"
              onClick={handleToggle}
            >
              {isActive ? <VscClose /> : <VscGrabber />}
            </button>
          </div>
        </div>
      </header>

      {/* Language Toggle */}
      <div className="language-container">
        <LanguageToggle />
      </div>

      {/* Mobile Menu */}
      <div className={`site-navigation ${isActive ? "open" : ""}`}>
        <nav className="menu-wrapper">
          <ul className="menu-list">
            <li><Link onClick={handleToggle} to="/">{getMenuText("home")}</Link></li>
            <li><Link onClick={handleToggle} to="/b2b">{getMenuText("b2b")}</Link></li>
            <li><Link onClick={handleToggle} to="/b2c">{getMenuText("b2c")}</Link></li>
            <li><Link onClick={handleToggle} to="/about">{getMenuText("about")}</Link></li>
            <li><Link onClick={handleToggle} to="/contact">{getMenuText("contact")}</Link></li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Headermain;
